import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JobInfoWrapper from './JobInfoWrapper';

export default class JobListSection extends Component {
  static propTypes = {
    formattedDate: PropTypes.string.isRequired,
    weekDay: PropTypes.string.isRequired,
    jobsList: PropTypes.array.isRequired,
    isPastJobsList: PropTypes.bool,
    isWorkerDetails: PropTypes.bool,
    isEventView: PropTypes.bool,
    history: PropTypes.object.isRequired,
    cancelJob: PropTypes.func,
    JobInfoComponent: PropTypes.func,
    editJobWorker: PropTypes.func,
    UIShowConfirm: PropTypes.func,
    UIShowAlert: PropTypes.func,
    onQuickViewOpen: PropTypes.func
  };

  render () {
    const { formattedDate, weekDay, jobsList, history, cancelJob, isPastJobsList, isWorkerDetails, JobInfoComponent,
      isEventView, editJobWorker, UIShowConfirm, UIShowAlert, onQuickViewOpen } = this.props;
    return (
      <div className='job-list-section'>
        <div className='list-group-title'><span className='week-day'>{ weekDay }</span> { formattedDate }</div>
        { jobsList.map(job => (
          <JobInfoWrapper
            key={job.id}
            job={job}
            JobInfoComponent={JobInfoComponent}
            history={history}
            cancelJob={cancelJob}
            isPastJobsList={isPastJobsList}
            isWorkerDetails={isWorkerDetails}
            isEventView={isEventView}
            editJobWorker={editJobWorker}
            UIShowConfirm={UIShowConfirm}
            UIShowAlert={UIShowAlert}
            onQuickViewOpen={onQuickViewOpen}
          />
        )) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobsList/JobListSection.js